<template>
  <div class="content-message">
    <div class="title">套餐订单</div>
    <div class="search">
      <el-form class="search-from" ref="form" :model="searchForm" label-width="85px">
        <el-form-item label="支付单号">
          <el-input style="width: 160px;" v-model="searchForm.payOrderNo" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input style="width: 160px;" v-model="searchForm.orderNo" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select v-model="searchForm.payType" placeholder="请选择" size="small"  :clearable="true">
            <el-option
              v-for="item in payTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付时间">
          <el-date-picker
            v-model="time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            value-format="yyyy-MM-dd HH:mm:ss"
          @change="getTime">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <div class="search-button">
            <div class="button-refer" @click="search">查询</div>
            <div class="button-export" @click="exportButton">导出</div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <div class="table-list">
        <el-table
          :data="list.list"
          style="width: 100%"
          :header-cell-style="bgColor"
        v-loading="loading">
          <el-table-column
            label="序号"
            width="180"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="订单号"
            width="180"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.orderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="支付单号"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.payOrderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="支付金额（元）"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.payAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="支付方式"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.payTypeStr }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="消费明细"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.consumeDetails }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="年限（年）"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.years }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="支付时间"
            width="180"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.payTime }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="list.total > 0"
          background
          class="align-right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="list.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="list.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { saasOrder} from "@/javaApi/saasOrder";
const saasM = new saasOrder()
export default {
name: "index",
  data(){
  return{
    searchForm:{
      payOrderNo:'',
      orderNo:'',
      payType:'',
      pageNo:1,
      pageSize:10,
      startTime:'',
      endTime:'',
    },
    payTypeList:[{
      label:'支付宝',
      value:2
    },{
      label:'微信',
      value:1
    },{
      label:'银联',
      value:0
    }],
    list:[],
    // 表头颜色
    bgColor:{
      background: '#FCFAF8'
    },
    time:'',
    currentPage:1,
    loading:true
  }
  },
  mounted() {
    this.getList()
  },
  methods:{
    pageChange(){

    },
    // 搜索
    search(){
      this.loading = true
      this.getList()
    },
    getList(){
      let params = this.searchForm
      saasM.getSetTheOrder(params).then(res=>{
        if(res.data.code == 200){
          this.list = res.data.data
          this.loading = false
        }else {
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val
      this.getList()
    },
    getTime(e){
      console.log(e)
      if(this.time != null){
        this.searchForm.startTime = e[0]
        this.searchForm.endTime = e[1]
      }else{
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
    },
    // 导出
    exportButton(){
      saasM.exportSetTheOrder(this.searchForm).then(res=>{
        console.log(res)
        if(res.status == 200){
          const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
          console.log('blob',blob)
          let url = window.URL.createObjectURL(blob);
          console.log('url',url)
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = window.URL.createObjectURL(blob);;
          a.download = "订单导出_" + this.formatDate(new Date()) + ".xls";
          a.click();
          window.URL.revokeObjectURL(url);
        }else{
          // this.$Message.error(res.info || res.message)
        }
      })
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y + m + d;
    },
  }
}
</script>

<style scoped lang="less">
.content-message{
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  min-height: 92%;
  .title{
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 25px;
  }
  .search{
    margin-top: 20px;
    display: flex;
    align-items: center;
    .search-from{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    .search-button{
      display: flex;
      align-items: center;
      margin-left: 20px;
      .button-refer{
        width: 76px;
        height: 32px;
        background: #FF8622;
        border-radius: 2px;
        text-align: center;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 32px;
        cursor: pointer;
      }
      .button-export{
        width: 76px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #FF8622;
        text-align: center;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FF8622;
        line-height: 32px;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
}
.table{
  margin-top: 20px;
}
/deep/.el-form-item{
  margin-bottom: 0;
}
/deep/.el-dialog__header{
  border-bottom: 1px solid #e5e5e5;
}
/deep/.el-input__inner:focus{
  border-color: #FF8622!important;
}
/deep/.el-range-editor.is-active, .el-range-editor.is-active:hover{
  border-color: #FF8622!important;
}
/deep/.el-date-table td.today{
  background: #FF8622;
}
/deep/.el-input__inner:hover{
  background: #FCF8F5;
  border-color: #FF8622!important;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #FF8622!important;
}
.align-right{
  text-align: right;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/SaasJoin/setTheOrder/index.vue